import React from 'react';
import Text from '../../Atomsv2/Text/Text';
import Tooltip from '../../Atomsv2/Tooltip/Tooltip';

const fmtDate = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('T')[0].split('-');
    return `${d}/${m}/${y}`;
};

/*
 * GanttRow — fila individual del diagrama de Gantt.
 *
 * Forma esperada de `row`:
 *   id        string | number   clave única
 *   label     string            texto en la columna izquierda
 *   start?    string            'YYYY-MM-DD' — inicio de la barra
 *   end?      string            'YYYY-MM-DD' — fin de la barra
 *   color?    string            color CSS de la barra (default: '#94a3b8')
 *   badge?    ReactNode         elemento en la parte derecha de la celda izquierda
 *   icon?     string            nombre de Material Icon
 *   indent?   0 | 1 | 2 | 3    nivel de sangría (0=raíz, 1=nivel medio, 2=tarea, 3=subtarea)
 *   isGroup?  boolean           true → fila de grupo (sin barra, fondo diferente)
 *   tooltip?  string            texto del tooltip; por defecto usa label + fechas
 *   progress? number            0-100 — % de completado (muestra franja en la barra)
 */
const GanttRow = ({ row, totalAncho, hoyX, hoyVisible, xDe, anchoDe, pxDia, onClick }) => {
    const rowClass = [
        'GanttChart__row',
        row.isGroup && row.indent === 0 ? 'GanttChart__row--area' : '',
        row.isGroup && row.indent === 1 ? 'GanttChart__row--proyecto' : '',
        !row.isGroup && row.indent === 3 ? 'GanttChart__row--subtask' : '',
        !row.isGroup && row.indent !== 3 ? 'GanttChart__row--task' : '',
    ].join(' ');

    const nombreClass = [
        'GanttChart__row-nombre',
        row.indent === 1 ? 'GanttChart__row-nombre--l1' : '',
        row.indent === 2 ? 'GanttChart__row-nombre--l2' : '',
        row.indent === 3 ? 'GanttChart__row-nombre--l3' : '',
    ].join(' ');

    const textWeight = row.indent === 0 ? 700 : row.indent === 1 ? 600 : 400;
    const textSize = row.isGroup ? 'small' : 'extra-small';

    const tooltipText = row.tooltip
        || `${row.label} · ${row.start?.split('T')[0]} → ${row.end?.split('T')[0]}`;

    return (
        <div className={rowClass} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>

            {/* Columna izquierda: icono + label + fechas + badge (sticky left) */}
            <div className="GanttChart__row-left">
                <div className={nombreClass}>
                    {row.icon && <span className="icon" data-icon={row.icon} />}
                    <div className="GanttChart__row-nombre-inner">
                        <Text size={textSize} weight={textWeight}>{row.label}</Text>
                        {!row.isGroup && row.start && (
                            <span className="GanttChart__row-dates">{fmtDate(row.start)} → {fmtDate(row.end)}</span>
                        )}
                    </div>
                </div>
                <div>{row.badge || null}</div>
            </div>

            {/* Columna derecha: línea de hoy + barra (si no es grupo) */}
            <div className="GanttChart__row-right" style={{ width: totalAncho, minWidth: totalAncho }}>
                {hoyVisible && <div className="GanttChart__hoy-line" style={{ left: hoyX }} />}

                {!row.isGroup && row.start && row.end && (
                    <Tooltip content={tooltipText}>
                        <div
                            className="GanttChart__bar"
                            style={{
                                left: xDe(row.start),
                                width: anchoDe(row.start, row.end),
                                backgroundColor: row.color || '#94a3b8',
                            }}
                        >
                            {pxDia >= 10 && (
                                <span className="GanttChart__bar-texto">{row.label} - {row.progress}%</span>
                            )}
                            {row.progress != null && (
                                <div className="GanttChart__bar-progress" style={{ width: `${row.progress}%` }}></div>
                            )}
                            
                        </div>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

export default GanttRow;
